import React from 'react';

const CategoryBanner = () => {
    return (
        <div className='profile-banner-container'>
            <div className="profile-banner">
                <img src={require('../../../images/offer/offer1.jpg')} className='h-100 w-100' alt="" />
                <div className="profile-banner-text">
                    <h1>All Categories</h1>
                </div>
            </div>
        </div>
    );
};

export default CategoryBanner;